import "./ScoreCard.scss";

import { HStack } from "Components/LabIZO/Stackizo";
import { ColorX } from "static";
import { HtmlParserWrapper } from "Components/HtmlParserWrapper";
import _ from "lodash";

const ScoreCardVar = ({ title, values, remarks }) => {
  if (values && !_.isString(values)) values = JSON.stringify(values);

  return (
    <div className="ScoreCard" style={{ background: ColorX.GetColorCSS("CardBG2") }}>
      <h4>{values && <HtmlParserWrapper html={values} />}</h4>
      <HStack width="100%">
        <p variant="body2">{title && <HtmlParserWrapper html={title} />}</p>
        <p variant="body2" style={{ color: ColorX.GetColorCSS("Primary"), paddingLeft: 5 }}>
          {remarks && "  -  " + <HtmlParserWrapper html={remarks} />}
        </p>
      </HStack>
    </div>
  );
};

export default ScoreCardVar;
